import { combineReducers, configureStore } from '@reduxjs/toolkit';
import { resetApp } from './actions';
import authReducer from './auth';
import accountManagementReducer from './accountManagement';
import productsReducer from './products/slice'; 
import workflowsReducer from './workflows/slice';
import productFormsReducer from './productsForm/slice'; 
import ticketingReducer from './ticketing/slice'; 
import customerReducer from './customer'; 
import productsSubitemsReducer from './productsSubitems/slice';
import payInvoiceReducer from './payInvoice/slice'; 
import docsVerificationReducer from './docsVerification/slice'; 

const appReducer = combineReducers({
  auth: authReducer,
  accountManagement: accountManagementReducer,
  products: productsReducer,
  productForms: productFormsReducer,
  productsSubitems: productsSubitemsReducer,
  workflows: workflowsReducer,
  ticketing: ticketingReducer,
  customer: customerReducer,
  payInvoice: payInvoiceReducer,
  docsVerification: docsVerificationReducer,
});

const rootReducer: typeof appReducer = (state, action) =>
  appReducer(resetApp.match(action) ? undefined : state, action);

export const store = configureStore({ reducer: rootReducer });

export type RootState = ReturnType<typeof appReducer>;
export type AppDispatch = typeof store.dispatch;

